<ion-header class="ion-no-border" mode="ios">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="{{ backHref }}"></ion-back-button>
    </ion-buttons>
    <ion-title>Edit Profile</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid>
    <ion-card class="banner-card">
      <ion-card-content>
        <div class="profile-container">
          <div class="profile-image">
            <img loading="lazy" [src]="profileImage" class="img" *ngIf="profileImage && !imageUploading" />
            <div class="loading" *ngIf="imageUploading">Uploading...</div>
            <div class="edit-icon" *ngIf="!imageUploading" (click)="enableImageEdit()">
              <ion-icon name="camera"></ion-icon>
            </div>
          </div>
          <input
            type="file"
            #imageInput
            (change)="processFile(imageInput)"
            accept="image/*"
            style="display: none"
          />
        </div>
        <div class="profile-details" [formGroup]="profileForm">
          <ion-item>
            <ion-label position="floating">Name</ion-label>
            <ion-input
              formControlName="name"
              aria-labelledby="Name"
              placeholder="Enter your name"
              required
            ></ion-input>
          </ion-item>
          <!-- Error Messages -->
          <ion-row class="ion-no-padding error-label"
           lines="none" *ngIf="isFieldInvalid('name')">
            <span *ngIf="profileForm.controls['name'].errors?.required">Name cannot be empty</span>
            <span *ngIf="profileForm.controls['name'].errors?.pattern">Please provide a valid name</span>
          </ion-row>
      
          <ion-item>
            <ion-label position="floating">Phone</ion-label>
            <ion-input
              formControlName="phone"
              aria-labelledby="Phone"
            ></ion-input>
          </ion-item>
      
          <ion-item>
            <ion-label position="floating">Email</ion-label>
            <ion-input
              formControlName="emailId"
              aria-labelledby="Email"
              placeholder="Enter your email address"
              required
            ></ion-input>
          </ion-item>
          <!-- Error message -->
            <ion-row class="ion-no-padding error-label"
           lines="none"*ngIf="isFieldInvalid('emailId')">
            <span *ngIf="profileForm.controls['emailId'].errors?.required">Email is required</span>
            <span *ngIf="profileForm.controls['emailId'].errors?.pattern">Please provide a properly formatted email</span>
          </ion-row>
        </div>
        <div class="center-button">
          <ion-button
            (click)="updateCustomerDetails()"
            [disabled]="profileForm.invalid"
            >Save Changes</ion-button
          >
        </div>
      </ion-card-content>
      
    </ion-card>
  </ion-grid>
</ion-content>
<ion-footer mode="ios">
  <ion-toolbar style="height: 25px;">
    <ion-title style="font-size: small; align-items: normal;">Powered by SimpayX</ion-title>
  </ion-toolbar>
</ion-footer>